import { styled } from '@mui/material/styles';

export const CoreWrapper = styled('div')``;

export const CoreCompetencyWrapper = styled('div')``;
